import { INeoAction } from './../Actions.interface';
import { STATUS, REQUEST_ACTIONS, STATIC_ACTIONS } from '../../Constants/Actions.constants';
import { SearchEvent } from '../../Models/DTO/SearchEvent.model';

const INITIAL_STATE: SearchEvent[] = [];

export default (state = INITIAL_STATE, { name, payload, status, type }: INeoAction) => {
  if (type === STATIC_ACTIONS.CLEAR_SEARCH) {
    return INITIAL_STATE;
  }

  if (name !== REQUEST_ACTIONS.SEARCH) {
    return state;
  }

  if (status === STATUS.SUCCESS) {
    return payload.eventGroups;
  }

  return state;
};
